import { computed, makeObservable } from 'mobx'
import { getValue, isPending } from 'mobx-async'

import { getHotelOptions } from './api/asyncHotelFilterArriere'

class AsyncHotelFilterStore {
  constructor() {
    makeObservable<AsyncHotelFilterStore, '__ASYNC_hotelOptions'>(this, {
      __ASYNC_hotelOptions: computed,
      hotelOptions: computed,
      isLoading: computed,
    })
  }

  private get __ASYNC_hotelOptions() {
    return getHotelOptions()
  }

  get hotelOptions() {
    return getValue(this.__ASYNC_hotelOptions) ?? []
  }

  get isLoading() {
    return isPending(this.__ASYNC_hotelOptions)
  }
}

export const asyncHotelFilterStore = new AsyncHotelFilterStore()
